import { ApiClient } from '@/apiClient'
import type { Issue } from '@/interfaces/Issue'
import type { GenericApiResponse } from '@/interfaces/GenericApiResponse'
import type { IssueCategory } from '@/interfaces/IssueCategory'
import type { PreUploadedFile } from '@/interfaces/PreUploadedFile'
import * as Sentry from "@sentry/browser";

export class IssueService {
  apiClient = new ApiClient()

  async saveIssue(issue: Issue): Promise<GenericApiResponse> {
    const apiResponse: GenericApiResponse = {
      success: false
    }

    await this.apiClient
      .saveIssue(issue)
      .then((response: any) => {
        if (response.success || response.status === 201) {
          apiResponse.success = true
          return response
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        apiResponse.error = 'Unexpected error occurred'
      })

    return apiResponse
  }

  async getCategories(): Promise<IssueCategory[]> {
    try {
      const response = await this.apiClient.getIssueCategories()
      return response.data ?? []
    } catch (err) {
      Sentry.captureException(err)
      return []
    }
  }

  async uploadAttachment(file: Blob, filename: string): Promise<PreUploadedFile | null> {
    try {
      const response = await this.apiClient.preUploadIssueAttachment(file, filename)
      return response.data ?? null
    } catch (err) {
      Sentry.captureException(err)
      return null
    }
  }
}
